import { generateJSON } from '@tiptap/core';
import type { JSONContent } from '@tiptap/react';
import { NOTE_EXTENSIONS } from './schema';

export function buildNoteDoc(html: string): JSONContent {
  return generateJSON(html || '<p></p>', NOTE_EXTENSIONS) as JSONContent;
}
